export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/b9b2f0a57fac91701be1c7b36fd000bf.jpg"
          alt="ビジョンを描く"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-20">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
          {/* Left Content */}
          <div className="flex-1 text-white text-center lg:text-left">
            <h1 className="text-6xl lg:text-7xl font-bold mb-6 leading-tight">
              2026年をデザインする
            </h1>
            <p className="text-3xl lg:text-4xl font-semibold mb-8 text-white/95 leading-relaxed">
              なりたい私を叶える<br />
              ビジョンマップ＆<br />
              パーソナリティ診断
            </p>
            <p className="text-xl lg:text-2xl mb-8 text-white/90">
              あなたの夢を現実に変える<br />
              特別な1日間のワークショップ
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <a
                href="#registration"
                className="whitespace-nowrap bg-teal-500 hover:bg-teal-600 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer"
              >
                今すぐ申し込む
              </a>
              <a
                href="#details"
                className="whitespace-nowrap bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-300 border-2 border-white/30 cursor-pointer"
              >
                詳細を見る
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
